export { default, default as Icon } from './Icon'
export * as IconStyles from './styles/Icon.style'
export { getIconSize, default as iconSizes } from './styles/mixins/iconSizes'

export type { IconProps, AppearanceKeys, StateKeys, IconSize } from './Icon.types'
export type { StyledIconProps } from './styles/Icon.style.types'
